/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_License_Row_None_BoatsInputs */

const es_marketplace_seo_license_row_none_boats = /** @type {(inputs: Marketplace_Seo_License_Row_None_BoatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasta 5 m y 15 CV (vel. ≤ 15 nudos)`)
};

const gl_marketplace_seo_license_row_none_boats = /** @type {(inputs: Marketplace_Seo_License_Row_None_BoatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ata 5 m e 15 CV (vel. ≤ 15 nós)`)
};

const en_marketplace_seo_license_row_none_boats = /** @type {(inputs: Marketplace_Seo_License_Row_None_BoatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up to 5 m and 15 HP (speed ≤ 15 knots)`)
};

/**
* | output |
* | --- |
* | "Up to 5 m and 15 HP (speed ≤ 15 knots)" |
*
* @param {Marketplace_Seo_License_Row_None_BoatsInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_license_row_none_boats = /** @type {((inputs?: Marketplace_Seo_License_Row_None_BoatsInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_License_Row_None_BoatsInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_license_row_none_boats(inputs)
	if (locale === "en") return en_marketplace_seo_license_row_none_boats(inputs)
	return es_marketplace_seo_license_row_none_boats(inputs)
});